import { Translation, QRType } from '../types';

export const id: Translation = {
  nav: {
    generator: 'Generator',
    scanner: 'Pemindai',
    mobile: 'Coba di ponsel',
    blog: 'Blog',
    langSelect: 'Pilih bahasa',
  },
  pageTitles: {
    generator: 'Generator Kode QR Gratis Online',
    scanner: 'Pemindai Kode QR Online',
    textToQr: 'Ubah Teks ke Kode QR',
    linkToQr: 'Ubah Link ke Kode QR',
  },
  pageMeta: {
    generator: {
      title:
        'Generator Kode QR Gratis — Buat QR Code Online (Tanpa Daftar, Tanpa Watermark, PNG/SVG/PDF) | YesQRCode',
      description:
        'Buat kode QR online gratis dengan YesQRCode. Konversi URL, teks, WiFi, vCard, dan lainnya. Unduh PNG, SVG, atau PDF berkualitas tinggi. Tanpa daftar, tanpa login, tanpa watermark — cepat, aman, dan selamanya gratis.',
      keywords: [
        'generator kode qr',
        'qr gratis',
        'buat qr online',
        'pembuat qr code',
        'qr code png',
        'qr code svg',
        'qr code pdf',
        'generator qr wifi',
        'generator qr vcard',
        'qr tanpa daftar',
      ],
    },
    scanner: {
      title:
        'Pemindai Kode QR Online — Pindai dari Gambar atau Kamera (Aman, Tanpa Daftar) | YesQRCode',
      description:
        'Pindai kode QR dan barcode online secara gratis. Unggah gambar atau gunakan kamera. Semua pemrosesan berjalan lokal tanpa upload. Aman, cepat, tanpa daftar, tanpa login, dan sepenuhnya gratis.',
      keywords: [
        'pemindai kode qr',
        'scan qr code online',
        'pembaca qr online',
        'scan qr dari gambar',
        'scan barcode online',
        'pemindai qr aman',
        'pemindai qr tanpa upload',
        'pemindai qr gratis',
        'pemindai qr di browser',
        'pemindai qr tanpa daftar',
        'pemindai qr tanpa login',
      ],
    },
    textToQr: {
      title: 'Konverter Teks ke Kode QR — Ubah Teks menjadi QR Seketika | YesQRCode',
      description:
        'Ubah catatan, pesan, atau teks apa pun menjadi kode QR online. Sesuaikan warna, bingkai, dan logo lalu unduh PNG, SVG, atau PDF tanpa perlu daftar maupun watermark.',
      keywords: [
        'teks ke qr code',
        'konversi teks ke qr',
        'generator qr teks',
        'qr teks online',
        'pesan ke qr code',
        'catatan ke qr',
        'qr teks gratis',
        'qr teks tanpa daftar',
        'text qr indonesia',
        'qr code untuk teks',
      ],
    },
    linkToQr: {
      title: 'Generator Link ke QR Code — Ubah URL jadi QR (Siap UTM) | YesQRCode',
      description:
        'Tempel URL website atau kampanye apa pun dan dapatkan QR code bermerk instan. Dukung warna, logo, bingkai khusus, serta unduhan PNG/SVG/PDF resolusi tinggi tanpa login.',
      keywords: [
        'link ke qr code',
        'ubah url ke qr',
        'generator qr url',
        'qr code untuk website',
        'link qr gratis',
        'qr utm',
        'url qr tanpa daftar',
        'qr kampanye',
        'generator link qr',
        'qr untuk tautan',
      ],
    },
  },
  hero: {
    title: 'Buat. Pindai. Ciptakan.',
    subtitle: 'Alat QR premium untuk semua kalangan.',
    desc: 'Bangun QR Code dengan logo, warna, dan file resolusi tinggi secara instan.',
  },
  info: {
    helpTitle: 'Pusat Bantuan',
    helpSubtitle: 'FAQ dan dukungan pelanggan',
    contactTitle: 'Hubungi kami',
    contactSubtitle: 'Kami siap membantu kapan saja.',
    privacyTitle: 'Kebijakan Privasi',
    termsTitle: 'Syarat & Ketentuan',
  },
  contactForm: {
    name: 'Nama',
    email: 'Email',
    message: 'Pesan',
    send: 'Kirim pesan',
    orEmail: 'atau email langsung ke',
    sending: 'Mengirim...',
    successTitle: 'Pesan terkirim!',
    successMessage: 'Terima kasih. Kami akan segera membalas.',
    sendAnother: 'Kirim pesan lagi',
    errorMessage: 'Pesan tidak dapat dikirim saat ini. Silakan email ke support@yesqrcode.com.',
  },
  generator: {
    highlights: {
      title: 'Buat QR code privat siap brand — gratis selamanya.',
      subtitle: 'Alat QR yang cepat, privat, dan fleksibel untuk alur kerja apa pun.',
      desc: 'Buat dan pindai QR berkualitas tinggi tanpa akun, watermark, atau upload data.',
      items: [
        {
          title: 'Privasi utama, generasi lokal',
          desc: 'QR dibuat di perangkat Anda — tanpa upload, pelacakan, atau penyimpanan.',
        },
        {
          title: 'Fitur lengkap untuk setiap kebutuhan',
          desc: 'URL, WiFi, vCard, barcode, logo, gradasi, frame — semuanya sudah ada.',
        },
        {
          title: 'Ramah seluler untuk semua orang',
          desc: 'Dioptimalkan untuk ponsel dan sentuhan agar proses membuat dan memindai mulus.',
        },
        {
          title: 'Gratis selamanya dan aman untuk bisnis',
          desc: 'Tanpa akun, watermark, atau batas scan — andal bagi tim dan brand mana pun.',
        },
      ],
    },
    featureSuite: {
      title: 'Suite QR lengkap berfokus privasi',
      subtitle: 'Seluruh kebutuhan untuk membuat QR bersih, bermerk, dan berkualitas tinggi di satu tempat.',
      categories: [
        {
          title: 'Semua tipe QR yang Anda perlukan',
          body: 'URL, teks, WiFi, email, telepon, SMS, vCard, tautan sosial, YouTube, barcode. Kode statis yang tidak kedaluwarsa.',
          items: [],
        },
        {
          title: 'Branding & desain',
          body: 'Kode aman untuk logo, gradasi, frame, bentuk, sudut, dan tata letak ramah scan.',
          items: [],
        },
        {
          title: 'Output & kualitas',
          body: 'Ekspor PNG, SVG, dan PDF berkualitas tinggi dengan preset untuk cetak dan digital.',
          items: [],
        },
        {
          title: 'Global & kemudahan pakai',
          body: 'UI multibahasa, desain mobile-first, serta alur kerja yang nyaman saat offline.',
          items: [],
        },
      ],
    },
    trust: {
      title: 'Trusted by creators, teams, and brands',
      subtitle:
        'YesQRCode is designed to be lightweight, predictable, and safe for long-running campaigns — with no accounts, no vendor lock-in, and no hidden limitations.',
      items: [
        'Zero onboarding',
        'Predictable static codes',
        'Enterprise-safe: no cloud processing',
        'Consistent branding across all assets',
      ],
    },
    sectionContent: 'Konten',
    sectionColors: 'Warna',
    sectionLogo: 'Logo',
    sectionFrame: 'Bingkai',
    sectionDesign: 'Desain',
    sectionCorrection: 'Koreksi kesalahan',
    labelUrl: 'URL situs',
    labelText: 'Teks biasa',
    labelSsid: 'Nama Wi-Fi (SSID)',
    labelPassword: 'Kata sandi',
    labelEncryption: 'Enkripsi',
    labelFgColor: 'Warna utama',
    labelBgColor: 'Warna latar',
    labelFrameText: 'Teks bingkai',
    labelFrameColor: 'Warna bingkai',
    placeholder: 'Masukkan konten di sini...',
    placeholders: {
      url: 'https://contoh.com',
      text: 'Masukkan teks',
      email: 'anda@email.com',
      subject: 'Subjek',
      message: 'Pesan Anda...',
      phone: '+62 812 0000 0000',
      ssid: 'NamaWiFi',
      password: 'Kata sandi',
      barcode: '123456789012',
    },
    download: 'Unduh PNG',
    downloadSvg: 'Unduh SVG',
    generateButton: 'Buat QR Code',
    copy: 'Salin SVG',
    uploadLogo: 'Unggah logo',
    preview: 'Pratinjau',
    lowQuality: 'Kualitas rendah',
    highQuality: 'Kualitas tinggi',
    foreverFree: 'Gratis selamanya • Tanpa login • Bebas untuk komersial',
    barcodeWarning: 'Logo dan bingkai tidak tersedia untuk kode batang.',
    barcodeColors: 'Anda tetap bisa mengubah warna di bawah.',
    frameStyles: {
      none: 'Tanpa bingkai',
      simple: 'Sederhana',
      balloon: 'Balon',
      box: 'Kotak',
      badge: 'Badge',
      polaroid: 'Polaroid',
      phone: 'Ponsel',
      header: 'Header',
      corner: 'Sudut',
    },
    vCard: {
      firstName: 'Nama depan',
      lastName: 'Nama belakang',
      mobile: 'HP',
      phone: 'Telepon',
      fax: 'Faks',
      email: 'Email',
      company: 'Perusahaan',
      job: 'Jabatan',
      street: 'Jalan',
      city: 'Kota',
      zip: 'Kode pos',
      state: 'Provinsi',
      country: 'Negara',
      website: 'Situs web',
    },
    types: {
      [QRType.URL]: 'URL',
      [QRType.TEXT]: 'Teks',
      [QRType.EMAIL]: 'Email',
      [QRType.PHONE]: 'Telepon',
      [QRType.SMS]: 'SMS',
      [QRType.WIFI]: 'Wi-Fi',
      [QRType.VCARD]: 'vCard',
      [QRType.FACEBOOK]: 'Facebook',
      [QRType.TWITTER]: 'X (Twitter)',
      [QRType.YOUTUBE]: 'YouTube',
      [QRType.BARCODE]: 'Kode batang',
    },
    guide: {
      title: 'Cara membuat QR Code kustom',
      steps: [],
    },
    gettingStarted: {
      title: 'Langkah cepat',
      steps: [
        {
          title: 'Pilih konten',
          text: 'Tentukan tipe QR dan isi semua data yang akan tampil saat dipindai.',
        },
        {
          title: 'Sesuaikan desain',
          text: 'Ubah warna, bentuk, dan tambahkan logo agar sesuai identitas merek.',
        },
        {
          title: 'Generate QR',
          text: 'Pilih resolusi, cek pratinjau, lalu uji dengan pemindai bawaan.',
        },
        {
          title: 'Unduh dan gunakan',
          text: 'Ekspor PNG atau SVG untuk materi cetak maupun digital.',
        },
      ],
    },
    about: {
      title: 'Generator QR berkualitas cetak',
      subtitle:
        'YesQRCode menghadirkan ekspor tajam, opsi desain lengkap, dan QR statis tanpa masa kedaluwarsa.',
      features: [
        'QR untuk sosial media & kampanye',
        'Kartu nama digital',
        'Warna dan frame kustom',
        'File siap cetak',
        'Boleh digunakan komersial',
        'Scan tanpa batas',
      ],
      content: [
        {
          title: 'Tidak pernah kedaluwarsa',
          body: 'QR statis akan aktif selamanya sehingga aman dipakai di materi jangka panjang.',
        },
        {
          title: 'Logo lebih mudah',
          body: 'Manfaatkan koreksi kesalahan hingga 30% untuk menempatkan logo tanpa mengurangi keterbacaan.',
        },
        {
          title: 'Kontrol desain penuh',
          body: 'Buat bentuk modul, gradien, dan bingkai yang menarik perhatian audiens.',
        },
        {
          title: 'Kualitas cetak tinggi',
          body: 'PNG resolusi tinggi dan SVG vektor siap digunakan untuk banner, kemasan, hingga merchandise.',
        },
        {
          title: 'Legal untuk bisnis',
          body: 'Gunakan di produk, promo offline, atau event tanpa biaya tambahan.',
        },
      ],
    },
    faq: {
      title: 'Pertanyaan umum',
      items: [
        { q: 'Apa itu QR Code?', a: 'Kode dua dimensi yang menyimpan link atau teks dan mudah dipindai.' },
        { q: 'Apakah gratis?', a: 'Ya, Anda bisa membuat QR tanpa limit untuk proyek personal maupun bisnis.' },
        { q: 'Bisakah diedit setelah dicetak?', a: 'Tidak. Buat QR baru jika ingin mengganti konten.' },
        { q: 'Ada batas scan?', a: 'Tidak ada. QR dapat dipindai sebanyak mungkin.' },
        { q: 'Data saya aman?', a: 'Kami tidak menyimpan data. File hanya dicache sementara untuk mempercepat unduhan.' },
        { q: 'vCard tidak terbaca?', a: 'Cobalah aplikasi pemindai lain karena sebagian app tidak mengikuti standar vCard.' },
        { q: 'QR tidak bekerja?', a: 'Periksa URL, pastikan kontras warna cukup, dan coba hilangkan logo saat pengujian.' },
        { q: 'Browser apa yang didukung?', a: 'Chrome, Firefox, Safari, dan Edge versi terbaru direkomendasikan.' },
      ],
    },
  },
  scanner: {
    title: 'Pemindai QR & barcode',
    subtitle: 'Gunakan kamera, unggah gambar, atau tempel dari clipboard.',
    cameraPermission: 'Aktifkan izin kamera di pengaturan browser.',
    result: 'Hasil',
    copy: 'Salin',
    copied: 'Disalin',
    open: 'Buka tautan',
    delete: 'Hapus',
    scanAgain: 'Pindai lagi',
    privacy: 'Pemrosesan berlangsung secara lokal. File tidak dikirim ke server.',
    upload: 'Unggah gambar',
    paste: 'Tempel (Ctrl+V)',
    drop: 'Tarik gambar ke sini',
    retry: 'Coba lagi',
    errorAccessDenied: 'Akses kamera ditolak',
    errorCamera: 'Beri izin kamera lalu coba ulang.',
    initializing: 'Menyiapkan kamera...',
    cameraActive: 'Kamera aktif',
    scannedItems: 'Daftar scan',
    recentScans: 'Riwayat (lokal)',
    clickToUpload: 'Klik untuk unggah',
    newBadge: 'BARU',
    tabCameraMobile: 'Kamera',
    tabCameraDesktop: 'Pindai kamera',
    emptyState: {
      title: 'Belum ada scan',
      desc: 'Unggah gambar atau buka tab kamera.',
    },
    highlights: {
      title: 'Pemindaian cepat dan privat',
      items: [
        { title: 'Dekode langsung di perangkat', desc: 'Tidak ada upload secara default; aman untuk URL dan aset sensitif.' },
        { title: 'Multi-format', desc: 'QR plus UPC/EAN, Code 128, ITF, dan format populer lainnya.' },
        { title: 'Aksi kilat', desc: 'Tarik file, tempel screenshot, atau beralih ke pemindaian langsung seketika.' },
        { title: 'Hebat di mobile', desc: 'UI dan alur kamera dioptimalkan untuk ponsel dan layar kecil.' },
      ],
    },
    intro: {
      title: 'Pemindai online aman',
      body: 'Dekode QR, UPC, EAN, ITF, dan format populer lainnya langsung di browser.',
    },
    howTo: {
      title: 'Cara menggunakan',
      methods: [
        { title: 'Unggah gambar', steps: ['Klik “Unggah gambar”', 'Pilih file', 'Lihat hasil secara instan'] },
        { title: 'Mode kamera', steps: ['Buka tab kamera', 'Beri izin', 'Arahkan ke kode hingga terbaca'] },
      ],
    },
    features: {
      title: 'Keunggulan',
      items: [
        { title: 'Gratis dan tanpa batas', desc: 'Tidak ada paywall atau watermark.' },
        { title: 'Dukung banyak format', desc: 'QR, Code 128, UPC, EAN, ITF, dll.' },
        { title: 'Privasi terjaga', desc: 'Tidak ada unggahan ke server pihak ketiga.' },
      ],
    },
    useCases: {
      title: 'Contoh penggunaan',
      items: [
        { title: 'Marketing & event', desc: 'Validasi materi cetak, menu digital, atau tiket QR.' },
        { title: 'Operasional & gudang', desc: 'Cek barcode inventaris dengan cepat.' },
        { title: 'Kebutuhan harian', desc: 'Akses Wi-Fi, formulir dan tautan penting secara aman.' },
      ],
    },
    faq: {
      title: 'FAQ pemindai',
      items: [
        { q: 'Apakah barcode bisa dibaca?', a: 'Ya. Hampir semua format populer didukung.' },
        { q: 'Bisa tempel screenshot?', a: 'Bisa. Gunakan Ctrl+V atau Cmd+V dari clipboard.' },
        { q: 'Apakah hasilnya tersimpan?', a: 'Hanya pada browser Anda. Anda dapat menghapus kapan saja.' },
        { q: 'Bisa offline?', a: 'Unggah gambar dapat offline; mode kamera butuh akses perangkat keras.' },
      ],
    },
  },
  blog: {
    title: 'Artikel & panduan',
    subtitle: 'Wawasan pemasaran, inspirasi desain, dan update produk seputar QR.',
    readMore: 'Baca artikel',
    back: 'Kembali ke blog',
    notFound: 'Artikel tidak ditemukan',
  },
  common: {
    footer: 'Solusi lengkap untuk membuat, mendesain, dan memindai QR Code profesional.',
    privacy: 'Privasi',
    terms: 'Ketentuan',
    contact: 'Kontak',
    scanToOpen: 'Pindai untuk membuka di ponsel',
    help: 'Bantuan',
    free: 'Gratis',
    product: 'Produk',
    resources: 'Resource',
    company: 'Perusahaan',
    api: 'API (segera hadir)',
    systemStatus: 'Sistem normal',
    footerDesc:
      'Generator dan pemindai QR paling canggih – cepat, aman, dan gratis untuk kreator maupun brand di Indonesia.',
  },
};
